export const VIEW_TYPE = {
  INVOICE_MANAGEMENT: 'invoice_management',
  INVOICE_ASSETS: 'invoice_asstes'
};
